<template>
  <div :style="{ 'background-color': background }" class="custom-status">
    <vs-row class="py-4">
      <vs-col vs-w="2" vs-type="flex" vs-justify="center" vs-align="center" class="p-2">
        <feather-icon :icon="icon" />
      </vs-col>
      <vs-col vs-w="10">
        <p class="text-status">{{ status }}</p>
        <p class="text-date">
          {{ $t('updated') | capitalize }} :
          {{ formatDate(date, 'MM/DD/YYYY h:mm:ss') }}
        </p>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
export default {
  props: {
    background: {
      type: String,
      default: 'grey',
    },
    status: {
      type: String,
      default: 'Status',
    },
    date: {
      type: String,
      default: new Date().toISOString().substr(0, 10) 
    },
    icon:{
      type: String,
      default: 'PlayIcon',
    }
  },
}
</script>

<style>
.custom-status {
  border-radius: 5px;
  color: #fff;
}
.text-status {
  font-size: 18px;
  font-weight: bold;
}
.text-date {
  font-size: 10px;
  color: #fff;
  font-weight: bold;
  
}
</style>